// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bgoK","left":"styles_left__aTgtU"};